module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 14-3bb0ab30bcc648bab85d192e55148306.jpg";